export class FieldModel {
	DataType: string;
	SubDataType?: string;
	DisplayText: string;
	Name: string;
	UIControl?: string;
	UIOptions?: UIOptions;
	UIEvents?: any;
	path?: string;
	options?: any[];
	hidden?: boolean;
	required?: boolean;
	disabled?: boolean;
	description?: string;
	customClass?: string;
}

class UIOptions {
	Url?: string;
	Mapper?: any;
	FilterName?: string;
	OptionsMapper?: any;
	LoadFromServer?: boolean;
	ShowClearButton?: boolean;
	OptionLabel?: string;
	Display?: string;
	ShowFilter?: boolean;
	IsInputGroup?: boolean;
	GroupElement?: InputGroupOptions;
	showLabel?: boolean;
	customTemplate?: boolean;
	customTemplateOptions?: CustomTemplateOptions;
	DisplayInputField?: boolean;
	suffix?: string;
	prefix?: string;
	min?: number;
	max?: number;
	step?: number;
	readonly?: boolean;
	tableConfig?: TableConfig;
	filters?: any;
	counterLabel?:string;
	PickListOptions?: any;
	SelectChips?: any;
	CalendarComponent?: any;

}

class CustomTemplateOptions {
	fieldContainerClass?: string;
	descriptionContainerClass?: string;
	fieldElementClass?: string;
	customActionsClass?: string;
}

export class TableConfig {
	isReorderable?: boolean;
	hasCounterInfo?:boolean;
	headerColumns?: string[];
	parentHeaders?: any[];
	childHeaders?: any[];
	childForm?: any;
}

class InputGroupOptions{
	Type: 'left' | 'right' | 'both';
	LeftElement?: ChildGroupOptions;
	RightElement?: ChildGroupOptions;
}

class ChildGroupOptions {
	icon?: string;
	text?: string;
}

export const FieldTypes = {
	AUTOCOMPLETE: 'Autocomplete',
	DROPDOWN: 'Dropdown',
	MULTISELECT: 'MultiSelect',
	PICKLIST: 'PickList'
}

export const FormControlArrayValues = [
	FieldTypes.AUTOCOMPLETE,
	FieldTypes.MULTISELECT,
	FieldTypes.PICKLIST
]

export class FormFieldModel {
	simpleField: boolean;
	key: string;
	label: string;
	hidden: boolean;
	customClass?: string;
	child?: FormFieldModel[][]
}
